import { render, staticRenderFns } from "./DeleteAllSharingLinksForms.vue?vue&type=template&id=7ffe79dc&"
import script from "./DeleteAllSharingLinksForms.vue?vue&type=script&lang=js&"
export * from "./DeleteAllSharingLinksForms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports